export default __webpack_public_path__ + "static/media/ups.91f3797e.svg";